import { defineAsyncComponent } from 'vue'
export default {
  clear: defineAsyncComponent(() => import("/build/layouts/Clear.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/build/layouts/Default.vue").then(m => m.default || m))
}